import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PrefixService {
  protected prefix: string = 'FRM-';

  public getPrefixedNumber(entity: any): string {
    return `${this.prefix}${entity.number}`;
  }

  public addPrefixToNumber(number: string | number): string {
    return `${this.prefix}${number}`;
  }

  public removePrefix(prefixedNumber: string): string {
    return prefixedNumber.replace(new RegExp(`^${this.prefix}`), '');
  }

  public hasPrefix(value: string): boolean {
    return value.startsWith(this.prefix);
  }
}
